import React from "react";
import { Modal, Button } from "react-bootstrap";

export const DeleteConnectionModal = ({ show, connectionName, deleting, onConfirm, onCancel }) => {
    return (
        <Modal show={show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Delete Connection</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Are you sure you want to delete the connection
                    {connectionName ? <> <strong>{connectionName}</strong></> : null}?
                </p>
                <p className="mb-0">
                    This will disconnect the brokerage and remove its stored connection
                    information. This action cannot be undone.
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onCancel} disabled={deleting}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={onConfirm} disabled={deleting}>
                    {deleting ? 'Deleting...' : 'Delete Connection'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
